import axios from 'axios';
import { getAuthHeaders } from './authHeader';

// The backend and this frontend deploy independently, and the `tag` query
// parameter (plus this whole available-tags shape) may not exist yet on
// whichever backend build is currently live. Every function here is written
// to fail open: on any error (network failure, a 404/500 from an older
// backend, a malformed response, etc.) it returns `null` rather than
// throwing, so callers can fall back to the previous, fully client-side
// behaviour (derive chips from loaded messages, filter loaded messages in
// memory) instead of showing an error or a blank page. The site must never
// look broken just because the two sides are a release apart.

const AVAILABLE_TAGS_URL = 'https://api.tinytexts.co/api/messages/available-tags';

// Fetches the tag chip list for an entire brand/category/search scope,
// computed by the server across ALL of that scope's messages (not just the
// messages currently loaded on screen). `params` is one of:
//   { brandId }
//   { categoryId }
//   { query, priorityIds } (search page; priorityIds may be omitted)
//
// Returns `string[]` on success (may be empty), or `null` on any failure.
export const fetchAvailableTags = async (params) => {
	try {
		const { data } = await axios.get(AVAILABLE_TAGS_URL, {
			params,
			headers: await getAuthHeaders(),
		});
		return Array.isArray(data?.tags) ? data.tags : [];
	} catch (err) {
		return null;
	}
};
